import Axios from "axios";
import { CustomerService_URL, PickerService_URL } from "../../../redux/Url";

export const productsYetToRacked = ({ access_token, ...params }) => {
  let url = new URL(`${PickerService_URL}/productsYetToRacked`);
  let keys = Object.keys(params);
  keys.forEach((item) => {
    if (params[item] || params[item] === 0) {
      url.searchParams.append(item, params[item]);
    }
  });
  const response = Axios({
    method: "GET",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    },
  });

  return response;
};

export const rackItemsToBin = ({ access_token, data, ...params }) => {
  let url = new URL(`${PickerService_URL}/rackItemsToBin`);
  let keys = Object.keys(params);
  keys.forEach((item) => {
    if (params[item] || params[item] === 0) {
      url.searchParams.append(item, params[item]);
    }
  });
  const response = Axios({
    method: "POST",
    url,
    data: [data],
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    },
  });
  return response;
};

export const fetchBinItems = ({ access_token, data, ...params }) => {
  let url = new URL(`${PickerService_URL}/fetchItemsAvailableInBin`);
  let keys = Object.keys(params);
  keys.forEach((item) => {
    if (params[item] || params[item] === 0) {
      url.searchParams.append(item, params[item]);
    }
  });
  const response = Axios({
    method: "GET",
    url,
    data: [data],
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    },
  });
  return response;
};
export const fetchBinReasons = ({ access_token, ...params }) => {
  let url = new URL(`${PickerService_URL}/getReasonMaster`);
  let keys = Object.keys(params);
  keys.forEach((item) => {
    if (params[item] || params[item] === 0) {
      url.searchParams.append(item, params[item]);
    }
  });
  const response = Axios({
    method: "GET",
    url,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
    },
  });
  return response;
};
